import { createAction, createSlice } from "@reduxjs/toolkit";
import TranslationsService from "../service/TranslationsService";
import { RootState } from "../store/store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { ITranslations } from "../interface/ITranslations";
import { TranslationParamModel } from "../model/translation";
import { logoutUser } from "./common";

type SliceState = { value: ITranslations ,status:string,apiCallCount:number } 
const initialState = {
  value: {},
  status: COMMON_STATUS.INITIAL,
  apiCallCount:0
} as SliceState;

const _service = new TranslationsService();

export const translationAsync = createAsyncThunk(
  "translations/translations",
  async (params:TranslationParamModel) => {
    const response = await _service.getTranslationsService(params.tenantName,params.language);
    return response;
  }
);

export const resetTranslation= createAction("translations/reset")


export const translationSlice = createSlice({
  name: "translations",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(translationAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(translationAsync.fulfilled, (state: SliceState, action: any) => {
       state.value = action.payload;
        state.status = COMMON_STATUS.DONE;
        state.apiCallCount = 0;
      })
      .addCase(translationAsync.rejected, (state) => {
        state.status = COMMON_STATUS.FAILED;
        state.apiCallCount  = state.apiCallCount+1;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetTranslation, () => {
        return initialState;
      });
  },
  reducers: {
    setTranslationStatus: (state,action) => {
      state.status=action.payload;
      state.apiCallCount = 0;
    },
  },
});

export const {setTranslationStatus} = translationSlice.actions;
export const getTranslationsInfo = (state:RootState) => state.translations.value;
export const getTranslationsLang = (state:RootState) => state.translations.value.language;
export const getTranslationsStatus = (state:RootState) => state.translations.status;
export const getTranslations = (state:RootState) => state.translations;
export default translationSlice.reducer;